import React from 'react';
import { StyleProp, Text, TextStyle } from 'react-native';
import Utilities from '../~Utilities/Utilities';

export interface IText2Eqv
{

  style: StyleProp<TextStyle>;
  
  getText: () => any;

  bindEvent : (onEvent    : (() => void), 
               bSubscribe : boolean) => void;
}

/*   ====================================================================   */

export default class Text2Eqv extends React.Component<IText2Eqv>
 {
  UpdateData()
  {
  var sNewText = this.props.getText();

  if (this.state.sText != sNewText)
      this.setState({sText: sNewText});
  }

  /*   -------------------------------------------------------------------   */
   
  constructor(props)
  {
  super(props);

  this.state      = {sText:this.props.getText()}
  this.UpdateData = this.UpdateData.bind(this);
  }

  /*   -------------------------------------------------------------------   */

  componentDidMount() 
  {
  this.props.bindEvent(this.UpdateData, true);
  }

  /*   -------------------------------------------------------------------   */

  componentWillUnmount() 
  {
  this.props.bindEvent(this.UpdateData, false);
  }

  /*   -------------------------------------------------------------------   */

  state = {
      sText: ""
   }

   /*   -------------------------------------------------------------------   */

  render() 
  {
  return(
        <Text style={this.props.style}>{this.state.sText}</Text>
        );
  }
}